import { Injectable } from "@angular/core";
import * as AWS from "aws-sdk/global";
import * as S3 from "aws-sdk/clients/s3";
import { Utils } from "tslint";
import { data } from "jquery";

@Injectable()
export class UploadService {
  fileaws:any='';
  constructor() {}
  // uploadFile(file) {
  // //  console.log("w");
  //   const contentType = file.type;
  //   const bucket = new S3({
  //     accessKeyId: "AKIAVKA6OPBVWMUE5VF7",
  //     secretAccessKey: "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",
  //     region: "ap-southeast-1",
  //   });
  //   const params = {
  //     Bucket: "qhse",
  //     Key: 'Questions/' + file.name,
  //     Body: file,
  //     ACL: "public-read",
  //     ContentType: contentType,
  //   };
  //   bucket.upload(params, function (err, data) {
  //     if (err) {
  //       console.log("There was an error uploading your file: ", err);
  //       return false;
  //     }
  //     console.log("Successfully uploaded file.", data);
  //     localStorage.setItem("file", data.Location);
  //     this.fileaws=data.Location;
  //     //resolve(data.Location);
  //     return true;
  //   });
    
  //     return  this.fileaws;
  //   console.log("wend");
  // }







  uploadFile(file): Promise<string> {
  return new Promise((resolve, reject) => {
    const bucket = new S3({
      accessKeyId: "AKIAVKA6OPBVWMUE5VF7",
      secretAccessKey: "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",
      region: "ap-southeast-1",
    });
    const params = {
      Bucket: "qhse",
      Key: 'Questions/' + file.name,
      Body: file,
      ACL: "public-read",
      ContentType: file.type, // Error occurs here if file is undefined
    };

    bucket.upload(params, (err, data) => {
      if (err) {
        console.error("There was an error uploading your file: ", err);
        reject(err);
      } else {
        console.log("Successfully uploaded file.", data);
        localStorage.setItem("file", data.Location);
        resolve(data.Location);
      }
    });
  });
}



}


// WEBPACK FOOTER //
// /app/src/app/services/upload.service.ts